<template>
	<div :class="classNames+'_content'" v-if="dialogVisibe" v-clickoutside='closeMarkerCard'>
		<div :class="classNames+'_title'">
			发送卡片
		</div>
		<div :class="classNames+'_main'">
			<div :class="classNames+'_headerbar'">
				 <el-button :type="activeIndex == -1 ? 'primary' : ''" @click="getCardInfo({value: ''},-1)">全部分组</el-button>
				 <el-button :type="activeIndex == index ? 'primary' : ''" v-for="(item,index) of typeList" :key="item.value" @click="getCardInfo(item,index)">{{item.label}}</el-button>
			</div>
			<div :class="classNames+'_searchbar'">
				 <el-input placeholder="请输入卡片标题" v-model="searchFormObj.title" class="input-with-select">
				    <el-button slot="append" icon="el-icon-search" @click="getCardsList()"></el-button>
				  </el-input>
			</div
			<div :class="classNames+'_body'">
				<card :listData="cardListData" :search="searchObj" @sendCardInfo="sendCardInfo" @getCardList="getCardList">
				</card>
			</div>
		</div>
	</div>
</template>
<script>
import { mapActions } from 'vuex'
import clickoutside from 'element-ui/src/utils/clickoutside'
import Pagination from '@/components/pagination/pagination.vue'
import card from './card.vue'
export default {
	props: {
		value: {
		    type: Boolean,
		    default: false
		},
	},
	directives:{
		clickoutside
	},
	data() {
		return {
            classNames: "markerCard",
			activeIndex: -1,
			searchFormObj: {
				card_type: '',
				page: 1,
				limit: 10,
				title: '',
				audit_status: 2
			},
			typeList: [
			    {
			        label: '留资卡片',
			        value: 3
			    },
			    {
			        label: '文字卡片',
			        value: 1
			    },
				{
				    label: '图片卡片',
				    value: 2
				},
				// {
				//     label: '电话拨打',
				//     value: 4
				// }
			],
			searchObj: {
				page: 1,
				limit: 10,
				audit_status: 2,
				title: '',
				card_type: ''
			},
			cardListData: {
				total: 0,
				data: []
			}
			
		}
	},
	computed: {
		dialogVisibe: {
			get() {
				return this.value
			},
			set(news) {
				this.$emit("input",news);
			}
		}
	},
	components: {
		card
	},
	created() {
		this.getCardsList()
	},
	methods: {
		...mapActions('dymessage', ['cardsList']),
		getCardInfo(data,index){
			this.activeIndex = index
			this.searchObj.card_type = data.value
			this.searchObj.page = 1
			this.getCardsList()
		},
		sendCardInfo(data){
			this.$emit('sendCardInfo',data)
		},
		closeMarkerCard(){
			this.$emit("input",false);
		},
		getCardList(data){
			this.searchObj.page = data
			this.getCardsList()
		},
		async getCardsList() {
			const params = {
				page: this.searchObj.page,
				limit: this.searchObj.limit,
				title: this.searchObj.title,
				card_type: this.searchObj.card_type,
				audit_status: this.searchObj.audit_status
			}
			let res = await this.cardsList(params)
			this.cardListData = {
				total: res.count,
				data: res.list
			}
		},
	}
}
</script>
<style lang="less">
    @classNames: markerCard;
	.@{classNames}_content{
		margin-top: 10px;
		padding: 10px;
		background-color: #818181;
		width: 360px;
		height: calc(100% - 10px);
		box-sizing: border-box;
	}
	.@{classNames}_title{
		height: 30px;
		color: #fff;
		font-size: 14px;
	}
	.@{classNames}_headerbar{
		text-align: center;
		white-space: nowrap;
		overflow-x: scroll;
		overflow-y: hidden;
		padding:0 10px 10px 10px;
		margin-bottom: 10px;
	}
	.@{classNames}_main{
		padding: 10px;
		height: calc(100% - 60px);
		background-color: #fff;
		
	}
	.@{classNames}_body{
	
	}
</style>

 